import { render, staticRenderFns } from "./BreadcrumbItem.vue?vue&type=template&id=d0362398&scoped=true&"
import script from "./BreadcrumbItem.vue?vue&type=script&lang=ts&"
export * from "./BreadcrumbItem.vue?vue&type=script&lang=ts&"
import style0 from "./BreadcrumbItem.vue?vue&type=style&index=0&id=d0362398&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d0362398",
  null
  
)

export default component.exports